// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/goods-action-button/index.css
// module id = 1771
// module chunks = 148